/*
 * VM - Our Experts
 * Shared behaviour for the standalone section and the "Our Experts" block
 * inside custom Product - VM. Hover is handled in CSS; this adds tap support
 * for touch devices (where there is no hover) and keyboard support.
 */
(function () {
  if (window.vmOurExpertInit) return;

  var isTouch = window.matchMedia('(hover: none)').matches;

  function closeAll(wrapper) {
    wrapper.querySelectorAll('.vm_expert_card.is-open').forEach(function (card) {
      card.classList.remove('is-open');
      card.setAttribute('aria-expanded', 'false');
    });
  }

  function setOpen(card, open) {
    card.classList.toggle('is-open', open);
    card.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initCarousel(wrapper) {
    var track = wrapper.querySelector('.vm_experts_grid');
    var prev = wrapper.querySelector('.vm_experts_arrow--prev');
    var next = wrapper.querySelector('.vm_experts_arrow--next');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.vm_experts_grid__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function refresh() {
      // Only offer arrows when the cards actually overflow the visible area.
      var overflows = track.scrollWidth - track.clientWidth > 2;
      prev.hidden = !overflows;
      next.hidden = !overflows;
      if (!overflows) return;

      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(refresh).observe(track);
    }

    refresh();
    // Images change the track width once they load.
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.vmExpertsReady === 'true') return;
    wrapper.dataset.vmExpertsReady = 'true';

    if (isTouch) wrapper.classList.add('vm_experts--touch');

    initCarousel(wrapper);

    wrapper.querySelectorAll('.vm_expert_card').forEach(function (card) {
      // Tap to reveal on touch devices, where there is no hover.
      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        if (!isTouch) return;
        var wasOpen = card.classList.contains('is-open');
        closeAll(wrapper);
        setOpen(card, !wasOpen);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setOpen(card, !card.classList.contains('is-open'));
        } else if (event.key === 'Escape') {
          setOpen(card, false);
        }
      });

      card.addEventListener('mouseleave', function () {
        setOpen(card, false);
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.vm_experts_wrp').forEach(initWrapper);
  }

  // Close an open card when tapping outside any experts grid.
  document.addEventListener('click', function (event) {
    if (event.target.closest('.vm_experts_wrp')) return;
    document.querySelectorAll('.vm_experts_wrp').forEach(closeAll);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init after a section or block is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });

  window.vmOurExpertInit = true;
})();
